import React, { useEffect, useMemo, useState } from 'react'
import { const_var, params } from '../../../../../redux/reducers/reducer'
import WallNameTemplete from '../../../WallName/WallNameTemplete';

const WallName = () => {
    const [porchOffset, setPorchOffset] = useState(0);

    const frontLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.lean_p_w) < 9) {
            if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos + params.lean_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanF_p_w, params.lean_p_w])

    const frontRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.leanR_p_w) < 9) {
            if((params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanF_p_w, params.leanR_p_w])

    useEffect(() => {
        if(params.add_left_front_lean_porch && !params.add_right_front_lean_porch) {
            setPorchOffset(-params.lean_p_w / 2)
        } else if(!params.add_left_front_lean_porch && params.add_right_front_lean_porch){
            setPorchOffset(params.leanR_p_w / 2)
        } else {
            setPorchOffset(0)
        }
    }, [params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.lean_p_w, params.leanR_p_w])

    
    
    let wallTemplates = [
        { position: [porchOffset, 0, (params.p_d / 2 + params.leanF_p_w + 1)], rotation: [0, 0, 0], slopeAngle: 60, value: 'Front Lean Side' },
        { position: [(params.leanF_p_d / 2 + (frontRightPosState ? -0.5 : 1)), frontRightPosState ? 0.7 : 0, (params.p_d / 2 + params.leanF_p_w / 2)], rotation: [0, Math.PI / 2, 0], slopeAngle: (frontRightPosState ? 0: 60), value: 'Front Lean Front' },
        { position: [-(params.leanF_p_d / 2 + (frontLeftPosState ? -0.5 : 1)), frontLeftPosState ? 0.7 : 0, (params.p_d / 2 + params.leanF_p_w / 2)], rotation: [0, -Math.PI / 2, 0], slopeAngle: (frontLeftPosState ? 0: 60), value: 'Front Lean Back' }
    ]

    if(params.add_storage_check_front){
        if(params.frontLeanStoragePosition!=0){
            let positionX = (params.frontLeanStoragePosition!=0)?(params.leanF_p_d / -2  + Math.round(params.frontLeanStoragePosition))+ 0.01: params.leanF_p_d /-2 + parseInt(params.add_storage_front) + 0.01;
            let frontStorage = {
                 position: [positionX, 0, (params.p_d / 2 + params.leanF_p_w / 2)], 
                 rotation: [0, - Math.PI / 2, 0], 
                 slopeAngle: 60,
                 value:  'Front Lean Storage Back'
                };
    
            wallTemplates = [...wallTemplates,frontStorage]
        }
        if(params.frontLeanStoragePosition != params.leanF_p_d - parseInt(params.add_storage_front) - 0.2){
            let positionX = (params.frontLeanStoragePosition!=0)?(params.leanF_p_d / -2  + parseInt(params.add_storage_front) + Math.round(params.frontLeanStoragePosition))+ 0.01: params.leanF_p_d /-2 + parseInt(params.add_storage_front) + 0.01;
            let frontStorage = {
                 position: [positionX, 0, (params.p_d / 2 + params.leanF_p_w / 2)], 
                 rotation: [0, Math.PI / 2, 0], 
                 slopeAngle: 60,
                 value:  'Front Lean Storage Front'
                };
    
            wallTemplates = [...wallTemplates,frontStorage]
        }
    }
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplete
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName